<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="4">
                <ListGroupCard
                    filterKey="display_name"
                    :model="forms"
                    :title="$t('label.forms')"
                >
                    <b-list-group-item
                        slot="modelContainer"
                        slot-scope="form"
                        action
                        :active="selectedFormId == form.item.id"
                        class="flex-column align-items-start"
                        @click="selectedFormData = form.item"
                    >
                        <div class="d-flex w-100 justify-content-between">
                            <h5 class="mb-1">{{ form.item.display_name }}</h5>
                            <small></small>
                        </div>
                        <!-- <p class="mb-1"> -->
                        <b-badge
                            class="float-sm-right"
                            variant="danger"
                            pill
                            v-if="!form.item.is_published"
                            >{{ $t('label.unpublished') }}</b-badge
                        >
                        <div class="float-sm-left">
                            {{ form.item.description }}
                        </div>
                        <!-- </p> -->
                    </b-list-group-item>
                </ListGroupCard>
            </b-col>
            <b-col sm="8">
                <Form
                    v-if="selectedFormData"
                    :formId="selectedFormId"
                    :formData="selectedFormData"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { Forms } from '@/models/Forms'
import ListGroupCard from '@/components/ListGroupCard'
import Form from './Form'
import { get as _get } from 'lodash'

export default {
    props: {},
    components: {
        ListGroupCard,
        Form,
    },

    data() {
        return {
            forms: new Forms(),
            selectedFormData: null,
            model: {},
        }
    },

    created() {
        // console.log('Forms created', this.forms)
        this.forms.fetch()
    },

    methods: {
        formSelected(form) {
            this.selectedFormData = form.item
            this.$refs.modal.show()
        },
    },

    computed: {
        canEditForms() {
            return this.$store.getters['auth/user'].role.rank < 30
                ? true
                : false
        },

        selectedFormId() {
            return _get(this, 'selectedFormData.id', null)
        },
    },
}
</script>
